<template>
  <el-dialog
    title="请选择您的身份（设置默认将在下次打开直接进入）"
    v-model="dialogVisible"
    :append-to-body='true'
    :close-on-click-modal="false"
    :before-close="dialogClose">
    <div class="iconList">
      <div class="avatar" v-for="(item,i) in property" :key="i" @mouseenter="handleImageActive(i)" @mouseleave="handleImageLeave" @click="handleSubmit">
        <div :class="imageIndex===i ?'image active':'image'">
          <!-- <div class="radiocheck" @click.stop>
            <el-radio v-model="radio" :label="item.appid" @change="changeDefault"><span></span></el-radio>
          </div> -->
          <div class="radiocheck" :class="radio === item.appid ? 'radiocheck-cur' : ''" :data-id="item.appid" @click.stop="changeDefault(item,item.appid)"><i class="iconfont icon-shezhimoren"></i></div>
          <img :src="$imgurl+item.Icons" v-if="item.Icons&&item.Icons.length>3">
          <img :src="'http://bigdata.topeti.com/PCRepository/image/verifyandqueryAvatar/0'+(item.Icons||1)+'.png'" v-else>
          <p class="tips" :class="radio === item.appid ? 'tips-show' : ''">已设置为默认</p>
        </div>
        <p class="ellipsisTwo">
          {{item.explain}}
        </p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import { addvalidaterecord, removevalidaterecord } from '@/port/clientSide/workbench'
  export default {
    name: "verificationSelect",
    props:["approvalId"],
    data() {
      return{
        radio: 0,
        dialogVisible: false,
        property: [],
        imageIndex: 0,
      }
    },
    methods: {
      vsMethods(pargam,radio){
        if(this.radio === 0){
          this.radio = radio || 0
        }
        this.property = pargam
        this.dialogVisible = true
      },
      handleImageActive(i){
        this.imageIndex = i
      },
      handleImageLeave(){
      this.imageIndex = null
      },
      changeDefault(item,i){
        if(this.radio == i){
          removevalidaterecord({approvalId: this.approvalId, appid:item.appid}).then(() => {
            this.radio = null;
          }).catch(error => { console.log(error) })
        }
        else{
          addvalidaterecord({approvalId: this.approvalId, appid:item.appid}).then(() => {
            this.radio = i;
          }).catch(error => { console.log(error) })
        }
      },
      dialogClose(){
        this.dialogVisible= false
      },
      handleSubmit(){
        this.$emit('VerificationSelectEmit',this.property[this.imageIndex])
        this.dialogClose()
      },
    }
  }
</script>
<style lang="scss" scoped>
  :deep(.el-dialog) {
    width: max-content;
    max-width: 840px;
    border-radius: 12px;
    .el-dialog__header{
      padding:11px 20px 10px;
      background: #F8F9FA;
      .el-dialog__title{
        font-size: 16px;
        padding-right: 20px;
      }
      .el-dialog__headerbtn{
        top:10px;
        font-size: 22px;
      }
    }
    .iconList{
      max-height: 545px;
      display: flex;
      flex-flow: wrap;
      justify-content: start;
      .avatar{
        display: inline-block;
        padding:0 10px 10px;
        vertical-align: top;
        width: 180px;
        &:nth-child(4n){
          margin-right: 0px;
        }
        .image {
          cursor: pointer;
          width: 180px;
          height: 180px;
          border-radius: 50%;
          position: relative;
          .radiocheck{
            position: absolute;
            z-index: 2;
            right: -6px;
            top: 0;
            width: 48px;
            height: 48px;
            background:#cecece;
            border-radius: 50%;
            transition: all .3s;
            opacity: 0;
            transform: translate(-20px,20px);
            .iconfont{
              position:absolute;
              left:50%;
              top:50%;
              font-size: 26px;
              color:#fff;
              transform: translate(-50%,-50%);
            }
          }
          .radiocheck-cur{
            background:#fff;
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
            .iconfont{
              color:#4e86ff;
            }
          }
          img{
            width:100%;
            height: 100%;
            -webkit-transform: scale(0.85);
            transform: scale(0.85);
            border-radius: 50%;
            transition: all .3s;
          }
          .tips{
            position:absolute;
            left:50%;
            bottom:0;
            margin-left: -62px;
            width:124px;
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            color:#fff;
            text-align: center;
            background: #4e86ff;
            border-radius: 15px;
            opacity: 0;
            transform: translateY(10px);
            transition: all .3s;
          }
          .tips-show{
            opacity: 0.8;
            transform: translateY(0);
          }
        }
        .active{
          box-shadow: 0 0 15px rgba(108, 187, 220, 1);
          .radiocheck{
            opacity: 1;
            transform: translate(0,0);
          }
          img{
            -webkit-transform: scale(1);
            transform: scale(1);
            
          }
        }
        .ellipsisTwo{
          font-size: 28px;
          line-height: 37px;
          padding-top: 10px;
          text-align: center;
          max-height: 74px;
          cursor: pointer;
        }
      }
    }
  }
</style>
